import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Services = () => {
  return (
    <div className="container py-5">

      {/* Title */}
      <div className="text-center mb-5">
        <h2 className="fw-bold text-danger">Services</h2>
        <p className="text-muted">
          Tamil Nadu Warehousing Corporation – Complete Service Details
        </p>
      </div>

      {/* Tabs */}
      {/* <ul className="nav nav-tabs justify-content-center mb-4">
        <li className="nav-item">
          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#activities">
            Key Activities
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#objectives">
            Other Objectives
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#services">
            Services Offered
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#terms">
            General Terms
          </button>
        </li>
      </ul> */}

      <div className="container my-5">

        {/* ================= KEY ACTIVITIES ================= */}
        <div className="row align-items-center mb-5" >
          <div className="col-md-5 text-center" >
            <img
              data-aos="zoom-in-right"
              src="https://ambronex.in/images/services/img1.png"
              alt="Key Activities"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-7" data-aos="fade-left">
            <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                Key Activities
              </h4>
              <ul>
                <li>Acquire land and build warehouses on scientific lines after conducting market survey.</li>
                <li>Provide negotiable warehouse receipts to farmers & depositors to avail credit facilities.</li>
                <li>Appoint Handling & Transport contractors for loading, unloading and transportation.</li>
                <li>Carry out disinfestation / pest control services in own godowns and other buildings.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* ================= OTHER OBJECTIVES ================= */}
        <div className="row align-items-center mb-5">
          <div className="col-md-7 order-md-1 order-2" data-aos="fade-right">
            <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                Other Objectives of TNWC
              </h4>
              <ul>
                <li>Provide assistance in orderly marketing through grade specification and warehouse receipts.</li>
                <li>Provide training to manage modern and non-modern warehouses.</li>
                <li>Create negotiable instruments for credit expansion through commercial banks.</li>
                <li>Assist government sponsored price support and price control schemes.</li>
                <li>Reduce waste and storage losses through scientific warehousing.</li>
                <li>Meet targets of stocking and delivery as agreed with depositors.</li>
                <li>Reduce warehousing cost through systematic cost control.</li>
                <li>Ensure quality service and minimize depositor complaints.</li>
                <li>Provide adequate storage facilities to consumers.</li>
                <li>Sustain quality and quantity of stored commodities.</li>
                <li>Provide training to manage modern warehouses.</li>
                <li>Publish grant, suspension or cancellation of licenses.</li>
                <li>Fix warehouse service charges.</li>
                <li>Conduct public auctions for deteriorating goods.</li>
                <li>Standardize weights, measures and gradations.</li>
                <li>Maintain proper books, accounts and records.</li>
              </ul>
            </div>
          </div>

          <div className="col-md-5 text-center order-md-2 order-1">
            <img
              data-aos="zoom-in-left"
              src="https://ambronex.in/images/services/img2.png"
              alt="Other Objectives"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>

        {/* ================= SERVICES OFFERED ================= */}
        <div className="row align-items-center mb-5">
          <div className="col-md-5 text-center">
            <img
              data-aos="zoom-in-right"
              src="https://ambronex.in/images/services/img3.png"
              alt="Services Offered"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-7" data-aos="fade-left">
            <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                Services Offered
              </h4>
              <ol>
                <li>Scientific Storage</li>
                <li>Credit Facility</li>
                <li>Special Storage for Hygroscopic Commodities</li>
                <li>Handling and Transport</li>
                <li>Port Handling</li>
                <li>Wagon Clearance</li>
                <li>Sale and Distribution</li>
                <li>Orderly Marketing</li>
                <li>Insurance of Stocks in Storage</li>
                <li>Disinfestation Extension Service</li>
                <li>Expert Advice and Training</li>
                <li>Import / Export / Bonded Warehouse Facilities</li>
                <li>Container Handling</li>
                <li>Consultancy Service</li>
              </ol>
            </div>
          </div>
        </div>

        {/* ================= GENERAL TERMS ================= */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="section-card">

              <h4 className="section-title text-danger fw-bold mb-4" data-aos="fade-left">
                General Terms for Storage
              </h4>

              {/* Responsive Columns */}
              <div className="row g-4" data-aos="fade-up">

                <div className="col-12 col-md-6 col-lg-3">
                  <h5 className="fw-bold text-primary">Types of Goods Accepted</h5>
                  <ul>
                    <li>Foodstuffs including edible oil seeds</li>
                    <li>Cattle feeds including oil cakes</li>
                    <li>Raw cotton and cotton seeds</li>
                    <li>Raw jute</li>
                    <li>Vegetable oils</li>
                    <li>Notified commodities</li>
                  </ul>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <h5 className="fw-bold text-primary">Storage Charge Methods</h5>
                  <ul>
                    <li>General Warehouse Basis</li>
                    <li>Area Basis Reservation</li>
                    <li>Tonnage Basis Reservation</li>
                  </ul>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <h5 className="fw-bold text-primary">Area Basis Reservation</h5>
                  <ul>
                    <li>Minimum reservation period: 3 months.</li>
                    <li>One month advance notice required for surrender.</li>
                    <li>Depositor arranges insurance.</li>
                    <li>Monthly claims generated.</li>
                    <li>Can use own labour or TNWC H&T services.</li>
                  </ul>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <h5 className="fw-bold text-primary">Tonnage Basis</h5>
                  <ul>
                    <li>Mainly for bulk fertilizer companies.</li>
                    <li>Minimum reservation: 100 Metric Tons.</li>
                    <li>Minimum period: 3 months.</li>
                    <li>One month advance notice for reduction/cancellation.</li>
                    <li>Transaction slips verified daily.</li>
                  </ul>
                </div>

              </div>

              {/* Tariff Table */}
              <h5 className="fw-bold mt-4 text-primary" data-aos="fade-left">
                General Warehouse Tariff
              </h5>

              <div className="table-responsive">
                <table className="table table-bordered table-striped" data-aos="fade-down">
                  <thead className="table-light">
                    <tr>
                      <th>Duration</th>
                      <th>Tariff</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>1 – 7 Days</td><td>40%</td></tr>
                    <tr><td>8 – 14 Days</td><td>60%</td></tr>
                    <tr><td>15 – 21 Days</td><td>80%</td></tr>
                    <tr><td>22+ Days</td><td>100%</td></tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Services;